export default __webpack_public_path__ + "static/media/usericon.5822897c.png";